import isMobile from '../../plugins/is-mobile.js';

const pc_url = 'pc';
const sp_url = 'sp';

if(isMobile(768)){
 $("#main-video").each(function(e,v) { 
  $(this).attr('src', $(v).attr('src').replace(pc_url, sp_url));
  $(this).attr('data-src', $(v).attr('data-src').replace(pc_url, sp_url));
  $(this).attr('poster', $(v).attr('poster').replace(pc_url, sp_url));
 });
}